
import { connect } from 'react-redux';
import PanelSelectionPage from '../components/PanelSelectionPage';
import { changePanelMaterial } from '../actions';
import { getPanelMaterials } from '../reducers/materialStore';
import localization from '../helpers/localization.js';

const mapDispatchToProps = (dispatch, ownProps) => ({
    panelMaterialChanged: (e) => {
        dispatch(changePanelMaterial(e.id));
    }
});

const mapStateToProps = (state, ownProps) => {
    let materials = getPanelMaterials(state);
    if (state.clientConfiguration.allowRemovalOfPanels) materials.push(noPanelSelection);
    return {
        panelMaterials: materials,
        loading: state.materialImage.isLoading,
        panelMaterial: state.paneling.panelMaterial,
        showPrices: state.clientConfiguration.showPrices,
        panelPrices: state.optionPricing.panels,
        nextPage: ownProps.nextPage
    };
};

const PanelSelectionPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PanelSelectionPage);

export default PanelSelectionPageContainer;
const noPanelSelection = {
    id: -1,
    thumbnail: "img/panels/noPanel.png",
    name: localization.noPaneling
}